import request from '@/utils/request'
import { IJobSocialData } from './types'

export const defaultSocialData: IJobSocialData = {
  id: 0,
  jobTitle: '',
  city: '',
  jobDesc: '',
  JobDemand: '',
  jobTime: '',
  salary: ''
}

export const selectSocialInfo = (params: any) =>
  request({
    url: '/job/selectSocialInfo',
    method: 'get',
    params
  })
export const insertSocialInfo = (data: any) =>
  request({
    url: '/job/insertSocialInfo',
    method: 'post',
    data
  })
export const updateSocialInfo = (id: number, data: any) =>
  request({
    url: `/job/updateSocialInfo/${id}`,
    method: 'post',
    data
  })
export const deleteSocialInfo = (id: number) =>
request({
  url: '/job/deleteSocialInfo/' + id,
  method: 'delete'
})